<template>
  <div class="detail">
    <van-nav-bar fixed placeholder title="订单详情" left-arrow @click-left="handleBackHome" />
    <div v-if="pageLoading" class="page-loading">
      <van-loading type="spinner" size="24px" vertical>加载中...</van-loading>
    </div>

    <div v-else>
      <div class="detail-card">
        <div class="header-row">
          <div class="title">{{ taskInfo.room_name }} - {{ taskInfo.shop_name }}</div>
          <div class="status-badge" :class="statusClass">{{ statusText }}</div>
        </div>

        <div class="info-list">
          <div class="info-item">
            <van-icon name="location-o" size="16" color="#999" />
            <div class="text">包间地址：{{ taskInfo.shop_address || '-' }}</div>
          </div>
          <div class="info-item">
            <van-icon name="clock-o" size="16" color="#999" />
            <div class="text">退房时间：{{ taskInfo.create_time || '-' }}</div>
          </div>
          <div class="info-item" v-if="taskInfo.start_time_str">
            <van-icon name="clock-o" size="16" color="#999" />
            <div class="text">开始时间：{{ taskInfo.start_time_str }}</div>
          </div>
          <div class="info-item" v-if="taskInfo.cleaner_name || taskInfo.cleaner_phone">
            <van-icon name="friends-o" size="16" color="#999" />
            <div class="text">
              保洁员：{{ taskInfo.cleaner_name || '-' }}，{{ taskInfo.cleaner_phone || '-' }}
            </div>
          </div>
        </div>
      </div>

      <RoomActions :roomId="taskInfo.room_id" :roomStatus="taskInfo.room_status" />

      <div class="bottom-action" v-if="isUnassigned">
        <van-button color="#38B00C" type="success" size="block" @click="handleAcceptTask">领取任务</van-button>
      </div>

      <div v-if="!isUnassigned">
        <div class="section-card">
          <van-field
            label="保洁任务"
            :value="taskForm.remark"
            readonly
            clickable
            right-icon="arrow"
            placeholder="请选择"
            :disabled="isFinished"
            @click="openTaskPicker"
          />
        </div>

        <div class="section-card">
          <div class="section-header">
            <div class="section-title">完成照片</div>
            <div class="counter">{{ completeFiles.length }}/6</div>
          </div>
          <van-uploader v-model="completeFiles" :max-count="6" :disabled="isFinished" />
        </div>

        <div class="section-card">
          <van-switch-cell title="是否报修" v-model="isRepair" :disabled="isFinished" />

          <div v-if="isRepair" class="repair-block">
            <div class="section-header column">
              <div class="section-title">报修申请</div>
              <div class="section-desc">如发现损坏物品，请填写报修信息</div>
            </div>

            <van-field
              v-model="repairForm.itemName"
              label="物品名称"
              placeholder="请输入损坏物品名称"
              :disabled="isFinished"
            />
            <van-field
              v-model="repairForm.desc"
              label="损坏描述"
              placeholder="请详细描述损坏情况"
              :disabled="isFinished"
            />

            <div class="section-header mt-12">
              <div class="section-title">损坏照片</div>
              <div class="counter">{{ repairFiles.length }}/3</div>
            </div>
            <van-uploader v-model="repairFiles" :max-count="3" :disabled="isFinished" />
          </div>
        </div>

        <div class="safe-height" v-if="!isFinished"></div>
        <div class="bottom-action" v-if="!isFinished">
          <van-button color="#38B00C" round block @click="handleCompleteTask">完成任务</van-button>
        </div>

        <van-popup v-model="showTaskSelect" position="bottom" safe-area-inset-bottom>
          <van-picker
            show-toolbar
            title="请选择保洁任务"
            :columns="taskColumns"
            @confirm="handleTaskConfirm"
            @cancel="showTaskSelect = false"
          />
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import RoomActions from '../../components/room-actions/index.vue'
import { acceptTask, completeTask, detail } from '../../api/lxz/cleaner'
import * as UploadApi from '../../api/lxz/upload'

export default {
  name: 'CleanerOrderDetail',
  components: {
    RoomActions
  },
  data() {
    return {
      taskInfo: {},
      taskId: '',
      pageLoading: true,
      showTaskSelect: false,
      taskForm: {
        remark: ''
      },
      taskList: [
        { value: '1', label: '清理桌面和处理垃圾' },
        { value: '2', label: '消毒桌面及清扫包间' },
        { value: '3', label: '简单清理' },
        { value: '4', label: '关闭全屋电源' }
      ],
      completeFiles: [],
      isRepair: false,
      repairForm: {
        itemName: '',
        desc: ''
      },
      repairFiles: []
    }
  },
  computed: {
    isUnassigned() {
      return Number(this.taskInfo.cleaner_user_id || 0) === 0 && parseInt(this.taskInfo.status) === 10
    },
    isFinished() {
      return String(this.taskInfo.status) === '30'
    },
    statusText() {
      const s = String(this.taskInfo.status || '')
      if (s === '30') return '已完成'
      if (s === '20') return '保洁中'
      if (s === '10') return '待处理'
      return '任务'
    },
    statusClass() {
      const s = String(this.taskInfo.status || '')
      if (s === '30') return 'green'
      if (s === '20') return 'orange'
      return 'gray'
    },
    taskColumns() {
      return this.taskList.map((t) => t.label)
    }
  },
  created() {
    this.taskId = this.$route.params.id
    this.fetchDetail(true)
  },
  methods: {
    handleBackHome() {
      this.$router.replace('/cleanerPage/home')
    },
    async handleAcceptTask() {
      try {
        await Dialog.confirm({ title: '领取任务', message: '确认领取该任务？' })
      } catch (e) {
        return
      }

      Toast.loading({ message: '领取中...', forbidClick: true, duration: 0 })
      try {
        const res = await acceptTask({ cleanerLogId: this.taskId })
        Toast.clear()
        if (res && res.status === 200) {
          await this.fetchDetail()
          return
        }
        Toast.fail('领取失败')
      } catch (e) {
        Toast.clear()
        Toast.fail('领取失败')
      }
    },
    openTaskPicker() {
      if (this.isFinished) return
      this.showTaskSelect = true
    },
    handleTaskConfirm(label) {
      this.taskForm.remark = label
      this.showTaskSelect = false
    },
    async fetchDetail(showLoading) {
      try {
        if (showLoading) this.pageLoading = true
        const res = await detail({ cleanerLogId: this.taskId })
        if (res && res.status === 200) {
          const data = res.data && res.data.data ? res.data.data : {}
          this.taskInfo = data

          if (!this.taskForm.remark) this.taskForm.remark = data.remark || this.taskList[0].label

          if (data.photos && Array.isArray(data.photos)) {
            this.completeFiles = data.photos.map((p) => ({ url: p.url }))
          }

          if (data.problem_description) {
            this.isRepair = true
            this.repairForm.itemName = data.problem_description.itemName || ''
            this.repairForm.desc = data.problem_description.desc || ''
            if (data.problem_description.photos && Array.isArray(data.problem_description.photos)) {
              this.repairFiles = data.problem_description.photos.map((p) => ({ url: p.url }))
            }
          }
        }
      } catch (e) {
        Toast.fail('获取详情失败')
      } finally {
        if (showLoading) this.pageLoading = false
      }
    },
    async uploadFileList(fileList) {
      const result = []
      for (let i = 0; i < fileList.length; i++) {
        const item = fileList[i]
        if (item && item.file instanceof File) {
          const files = await UploadApi.imageInfo([item])
          console.log(files)  
          if (Array.isArray(files) && files[0]) {
            result.push({ fileId: files[0].file_id, url: files[0].preview_url })
          }
        } else if (item && item.url) {
          result.push({ fileId: '', url: item.url })
        }
      }
      return result
    },
    async handleCompleteTask() {
      if (this.completeFiles.length === 0) {
        Toast('请先上传完成照片')
        return
      }

      try {
        await Dialog.confirm({ title: '确认完成', message: '确认已完成所有清洁任务？' })
      } catch (e) {
        return
      }

      Toast.loading({ message: '上传中...', forbidClick: true, duration: 0 })
      try {
        const photos = await this.uploadFileList(this.completeFiles)
        const postdata = {
          cleanerLogId: this.taskId,
          photos,
          remark: this.taskForm.remark
        }

        if (this.isRepair) {
          const repairPhotos = await this.uploadFileList(this.repairFiles)
          postdata.problem_description = {
            itemName: this.repairForm.itemName,
            desc: this.repairForm.desc,
            photos: repairPhotos
          }
        }

        const res = await completeTask(postdata)
        Toast.clear()
        if (res && res.status === 200) {
          Toast.success('完成成功')
          // 刷新
          this.fetchDetail()
          // setTimeout(() => {
          //   this.$router.back()
          // }, 800)
        } else {
          Toast.fail('完成失败')
        }
      } catch (e) {
        Toast.clear()
        Toast.fail('完成失败')
      }
    }
  }
}
</script>

<style scoped>
.detail {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 12px;
}
.page-loading {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detail-card,
.section-card {
  background: #fff;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f5f5f5;
}
.title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
.status-badge {
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 6px;
  flex-shrink: 0;
}
.status-badge.orange {
  background: #ff9900;
}
.status-badge.green {
  background: #2b9939;
}
.status-badge.gray {
  background: #999;
}
.info-list .info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}
.info-list .info-item:last-child {
  margin-bottom: 0;
}
.text {
  font-size: 13px;
  color: #666;
  margin-left: 8px;
  line-height: 1.4;
  flex: 1;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.section-header.column {
  flex-direction: column;
  align-items: flex-start;
}
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
}
.section-desc {
  font-size: 12px;
  color: #999;
  margin-top: 6px;
}
.counter {
  font-size: 12px;
  color: #999;
}
.mt-12 {
  margin-top: 12px;
}
.repair-block {
  margin-top: 10px;
}
.bottom-action {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  padding: 20px 12px;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.06);
  z-index: 100;

}
.safe-height {
  height: 70px;
}
</style>
